import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../../../../shared/services/base-api.service';
import { environment } from '../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BaseAddressyApiService extends BaseApiService {
  constructor(http: HttpClient) {
    const baseApiUrl: string = environment.addressy.apiUrl;
    const baseOptions = { params: { key: environment.addressy.apiKey } };

    super(http, baseApiUrl, baseOptions);
  }
}
